<div class="buysellcontrol_wrapper buysellcontrol_wrapper_buy">
    <app-view-balance [buyorsell]="'buy'"></app-view-balance>
    <app-limitorder-form [buyorsell]="'buy'" [updateBuyForm]="updateBuyForm"></app-limitorder-form>
</div>
<div class="buysellcontrol_wrapper buysellcontrol_wrapper_sell">
    <app-view-balance [buyorsell]="'sell'"></app-view-balance>
    <app-limitorder-form [buyorsell]="'sell'" [updateSellForm]="updateSellForm"></app-limitorder-form>
</div>